<div class="tw-min-h-screen tw-bg-slate-50 tw-py-12 tw-px-4">
  <div class="tw-max-w-4xl tw-mx-auto">

    <div class="tw-mb-10">
      <h1 class="tw-text-2xl tw-font-bold tw-text-slate-900">Acerca de Nosotros</h1>
      <p class="tw-mt-1 tw-text-slate-500 tw-text-sm">Conoce la plataforma de empleo tech más grande de México</p>
    </div>

    <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-8 tw-mb-8" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center">

        <div class="tw-grid tw-grid-cols-2 tw-gap-3">
          <img loading="lazy" src="assets/img/home-1/1nosotros.jpg" alt="TG Empleos Nosotros" title="TG Empleos Nosotros" class="tw-rounded-xl tw-object-cover tw-w-full tw-h-48">
          <img loading="lazy" src="assets/img/home-1/2nosotros.jpg" alt="TG Empleos Nosotros 1" title="TG Empleos Nosotros 1" class="tw-rounded-xl tw-object-cover tw-w-full tw-h-48">
          <div class="tw-col-span-2 tw-flex tw-justify-center tw-mt-2">
            <a routerLink="/registrarse"
              class="tw-inline-block tw-px-6 tw-py-2.5 tw-rounded-xl tw-bg-blue-600 tw-text-white tw-font-semibold tw-text-sm tw-no-underline tw-transition hover:tw-bg-blue-700"
              style="box-shadow:0 1px 3px rgba(37,99,235,.3)">
              Crear cuenta
            </a>
          </div>
        </div>

        <div>
          <h2 class="tw-text-xl tw-font-bold tw-text-slate-900 tw-mb-4">¡Hazte visible!</h2>
          <ul class="tw-flex tw-flex-col tw-gap-3 tw-mb-6">
            <li class="tw-flex tw-items-start tw-gap-2 tw-text-sm tw-text-slate-600">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="tw-w-4 tw-h-4 tw-mt-0.5 tw-text-blue-500 tw-shrink-0"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd"/></svg>
              No importa donde te encuentres, con TG Empleos diversos profesionistas de TI podrán conocer las vacantes que publiques.
            </li>
            <li class="tw-flex tw-items-start tw-gap-2 tw-text-sm tw-text-slate-600">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="tw-w-4 tw-h-4 tw-mt-0.5 tw-text-blue-500 tw-shrink-0"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd"/></svg>
              Publica tus vacantes en cualquier momento y únete a esta red de reclutamiento enfocado a perfiles TI.
            </li>
            <li class="tw-flex tw-items-start tw-gap-2 tw-text-sm tw-text-slate-600">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="tw-w-4 tw-h-4 tw-mt-0.5 tw-text-blue-500 tw-shrink-0"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd"/></svg>
              ¡No esperes más! y regístrate.
            </li>
          </ul>

          <div class="tw-grid tw-grid-cols-2 tw-gap-4">
            <div class="tw-bg-slate-50 tw-rounded-xl tw-p-4 tw-text-center tw-border tw-border-slate-100">
              <p class="tw-text-2xl tw-font-bold tw-text-slate-900">{{estadisticas.vacantes}}+</p>
              <p class="tw-text-xs tw-text-slate-500 tw-mt-1">Vacantes Publicadas</p>
            </div>
            <div class="tw-bg-slate-50 tw-rounded-xl tw-p-4 tw-text-center tw-border tw-border-slate-100">
              <p class="tw-text-2xl tw-font-bold tw-text-slate-900">{{ estadisticas.usuarios }}+</p>
              <p class="tw-text-xs tw-text-slate-500 tw-mt-1">CV Enviados</p>
            </div>
            <div class="tw-bg-slate-50 tw-rounded-xl tw-p-4 tw-text-center tw-border tw-border-slate-100">
              <p class="tw-text-2xl tw-font-bold tw-text-slate-900">{{ estadisticas.empresa }}+</p>
              <p class="tw-text-xs tw-text-slate-500 tw-mt-1">Empresas Registradas</p>
            </div>
            <div class="tw-bg-slate-50 tw-rounded-xl tw-p-4 tw-text-center tw-border tw-border-slate-100">
              <p class="tw-text-2xl tw-font-bold tw-text-slate-900">{{estadisticas.contratados}}+</p>
              <p class="tw-text-xs tw-text-slate-500 tw-mt-1">Contratados</p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-8" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center">

        <div class="tw-grid tw-grid-cols-2 tw-gap-3">
          <img loading="lazy" src="assets/img/home-1/3inicio.jpg" alt="TG Empleos 3" title="TG Empleos 3" class="tw-rounded-xl tw-object-cover tw-w-full tw-h-44 tw-row-span-2">
          <img loading="lazy" src="assets/img/home-1/4inicio.jpg" alt="TG Empleos 4" title="TG Empleos 4" class="tw-rounded-xl tw-object-cover tw-w-full tw-h-20">
          <img loading="lazy" src="assets/img/home-1/5inicio.jpg" alt="TG Empleos 5" title="TG Empleos 5" class="tw-rounded-xl tw-object-cover tw-w-full tw-h-20">
        </div>

        <div>
          <h2 class="tw-text-xl tw-font-bold tw-text-slate-900 tw-mb-3">¿Por qué somos tu mejor opción?</h2>
          <p class="tw-text-sm tw-text-slate-600 tw-mb-3 tw-leading-relaxed">
            Apoyamos a pequeñas y grandes empresas a formar los mejores equipos de trabajo con profesionales capacitados en tecnologías de vanguardia más demandadas por el mercado laboral.
          </p>
          <p class="tw-text-sm tw-text-slate-600 tw-mb-5 tw-leading-relaxed">
            Cubre cualquier perfil desde un nivel básico hasta uno especializado, con el talento adecuado.
          </p>
          <div class="tw-grid tw-grid-cols-2 tw-gap-3">
            <div class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="tw-w-4 tw-h-4 tw-text-emerald-500 tw-shrink-0"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd"/></svg>
              Profesionistas capacitados
            </div>
            <div class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="tw-w-4 tw-h-4 tw-text-emerald-500 tw-shrink-0"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd"/></svg>
              Tecnologías de mayor demanda
            </div>
            <div class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="tw-w-4 tw-h-4 tw-text-emerald-500 tw-shrink-0"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd"/></svg>
              Postulaciones inmediatas
            </div>
            <div class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="tw-w-4 tw-h-4 tw-text-emerald-500 tw-shrink-0"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd"/></svg>
              Gran difusión y alcance
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
